import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import useCustomHistory from '../../Hooks/UseCustomHistory';
import Divider from '../../Components/Common/Atoms/Divider';
import Breadcrumb from '../../Components/Common/Modules/Breadcrumb';
import Card from '../../Components/Common/Modules/Card';
import Toast from '../../Components/Common/Modules/Toast';
import Paragraph from '../../Components/Common/Atoms/Paragraph';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import PortalLoading from '../../Helpers/PortalLoading';
import ErrorBoundary from '../../Components/Common/Organism/ErrorBoundary';
import useObtenerRelacionClub from '../../Hooks/useObtenerRelacionClub';
import {
    getCondicionSuscripcionUsuario,
    estadoSuscripcion,
} from '../../Models/CondicionSuscripcion';
import useSuscripciones from '../../Hooks/useObtenerSuscripciones';
import useGetFlow from '../../Hooks/useGetFlow';
import MensajeExito from '../../Components/Features/MiClub/MensajeExito';
import DesvincularService from '../../Services/DesvincularService';
import SessionHandler from '../../Handlers/Session';
import Metering from '../../Handlers/Metering';
import { CookieContext } from '../../Contexts/CookieContext';
import { useLocation } from 'react-router';
import Flow from '../../Models/Flow';
import Url from '../../Helpers/Url';
import IncentivarVincularClubBanner from '../../Components/Common/Banners/IncentivarVincularClub';
import IncentivarSuscripcionBanner from '../../Components/Common/Banners/IncentivarSuscripcion';
import IncentivarAgregarClubBanner from '../../Components/Common/Banners/IncentivarAgregarClub';
import IncentivarCambiarBlackBanner from '../../Components/Common/Banners/IncentivarCambiarBlack';
import TitleWeb from '../../Components/Common/Web/Title';
import Datadog from '../../Helpers/Datadog';
import { CustomEventsDatadog } from '../../Config/Datadog';
import PathsConfig from '../../Config/RoutePaths';
import useObtenerVerificacionCredenciales from '../../Hooks/useObtenerVerificacionCredenciales ';
import { ToastBloqueoCredenciales } from './../../Components/Common/Banners/ToastBloqueoCredenciales';

const MiClub = (props) => {
    const [_, setUpdateCookie] = useContext(CookieContext);

    const location = useLocation();
    const respuestaDesvincular = location.state && location.state.respuesta;

    let history = useCustomHistory({
        event: 'ASOCIARTARJETA',
        data: 'ASOCIARTARJETA',
    });

    const [respuesta, setRespuesta] = useState('');
    const [isLoadingDesvincular, setIsLoadingDesvincular] = useState(false);
    //const [dataRelacionClub, errorRelacionClub, isLoadingRelacion] = useObtenerRelacionClub(2); //descomentar para mock
    const [dataRelacionClub, errorRelacionClub, isLoadingRelacion] =
        useObtenerRelacionClub();
    const [suscripciones, errorSuscripciones, isLoadingSuscripciones] =
        useSuscripciones();
    const condicionSuscripcion = getCondicionSuscripcionUsuario(
        dataRelacionClub?.response
    );
    const conSuscripciones = suscripciones?.length > 0;
    const [flowActivar, isLoadingFlow, errorFlow] = useGetFlow(Flow.Wall);
    const [isBlockedCredenciales, errorVerificacionCredenciales, isLoadingVerificacionCredenciales] = useObtenerVerificacionCredenciales();

    const handleClickDesvincular = () => {
        dataRelacionClub.response.categoria == 'Classic'
            ? desasociar('Desvincular')
            : history.push({ pathname: PathsConfig.MiClubDesvincular });
    };

    const desasociar = async (respuestaEvent) => {
        setIsLoadingDesvincular(true);
        await DesvincularService()
            .then((res) => {
                if (res.code == '0000') {
                    Datadog.trackCustomEvent(
                        CustomEventsDatadog.desvincularCredencial
                    );
                    SessionHandler.Reload().then(() =>
                        Metering.obtenerCookieSuscriptor().then(() => {
                            setIsLoadingDesvincular(false);
                            setUpdateCookie(true);
                            setRespuesta(respuestaEvent);
                        })
                    );
                }
                setRespuesta('');
            })
            .catch((error) => {
                console.log(error);
                setRespuesta('');
                setIsLoadingDesvincular(false);
            });
    };

    return (
        <div>
            <PortalLoading isLoading={isLoadingDesvincular}></PortalLoading>
            <Breadcrumb
                firstItem="Club LA NACION"
                text="Vincular credencial"
                href="#"
            />
            <TitleWeb text="Vincular credencial" />
            <div className="container-streched">
                {/*Pantalla de carga*/}
                <LoadingSpinner
                    isLoading={
                        isLoadingFlow ||
                        isLoadingRelacion ||
                        isLoadingSuscripciones ||
                        isLoadingVerificacionCredenciales
                    }
                >
                    <ErrorBoundary error={errorRelacionClub || errorFlow || errorVerificacionCredenciales || (errorSuscripciones && !suscripciones)}>

                        {
                            isBlockedCredenciales ? (
                                <ToastBloqueoCredenciales title={"Atención"} estado={"alert"} subtitle={"La vinculación de tu credencial está temporalmente suspendida."}/>
                            ) : (
                                <>
                                    {props.location &&
                                        props.location.state &&
                                        props.location.state.succes && (
                                            <MensajeExito></MensajeExito>
                                        )}

                                    {/*Mensaje desvinculacion exitosa*/}
                                    {respuestaDesvincular == 'Desvincular' && (
                                        <Toast status="success" title="Desvinculación exitosa">
                                            La desvinculación fue solicitada.
                                        </Toast>
                                    )}

                                    {/*Pantalla de desvinculacion directa*/}
                                    {respuesta == 'Desvincular' && (
                                        <Toast
                                            status="success"
                                            title="Desvinculación exitosa"
                                        >
                                            La desvinculación fue solicitada.
                                        </Toast>
                                    )}

                                    {dataRelacionClub &&
                                        (!dataRelacionClub.response ||
                                            !dataRelacionClub.nroCredencial) && (
                                            <IncentivarVincularClubBanner />
                                        )}

                                    {dataRelacionClub &&
                                        dataRelacionClub.response &&
                                        dataRelacionClub.response.tieneClub &&
                                        respuesta == '' && (
                                            <>
                                                <Card
                                                    isDesvincular={
                                                        dataRelacionClub.response
                                                            .desasociarHabilitado
                                                    }
                                                    onClickDesvincular={
                                                        handleClickDesvincular
                                                    }
                                                    isActivar={Flow.TieneCredencialPremiumBlack(
                                                        flowActivar
                                                    )}
                                                    linkActivar={Url.ObtenerLinkActivarSuscripcion()}
                                                    type={
                                                        dataRelacionClub.response.categoria
                                                    }
                                                    cardNumber={
                                                        dataRelacionClub.response
                                                            .nroCredencial
                                                    }
                                                />

                                                {dataRelacionClub.response.categoria !==
                                                    'Black' && (
                                                        <IncentivarCambiarBlackBanner />
                                                    )}
                                                <Divider />
                                                <Paragraph
                                                    size="--twoxs"
                                                    mod="--arial --font-regular"
                                                >
                                                    Si tenés dudas o querés realizar una
                                                    consulta comunicate al:{' '}
                                                    <strong>5199-4740</strong>
                                                </Paragraph>
                                                <br />
                                                <br />
                                                <br />
                                            </>
                                        )}

                                    {
                                        //TODO: Si tiene suscripciones digitales y no tiene tarjetas (tiene combo 1)
                                        conSuscripciones &&
                                        (condicionSuscripcion ===
                                            estadoSuscripcion.SIN_SUSCRIPCION ||
                                            condicionSuscripcion ===
                                            estadoSuscripcion.SUSCRIP_SIN_CLUB) && (
                                            <IncentivarAgregarClubBanner />
                                        )
                                    }

                                    {
                                        //TODO: Si no tiene suscripciones digitales activas, se muestra
                                        ((condicionSuscripcion ===
                                            estadoSuscripcion.SIN_SUSCRIPCION &&
                                            !conSuscripciones) ||
                                            condicionSuscripcion ===
                                            estadoSuscripcion.CLASSIC) && (
                                            <IncentivarSuscripcionBanner />
                                        )
                                    }

                                </>
                            )
                        }



                    </ErrorBoundary>
                </LoadingSpinner>
            </div>
        </div>
    );
};

MiClub.propTypes = {
    succes: PropTypes.bool,
};

export default MiClub;